<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.matCode" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="类型" class="EL-Form-Item">

                        <el-select v-model="pagination.type" placeholder="请选择" clearable="clearable" filterable @change="saveSearch()">
                          <el-option  :value="10" label="装配"></el-option>
                          <el-option  :value="20" label="外圈"></el-option>
                          <el-option  :value="30" label="内圈"></el-option>

                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="状态" class="EL-Form-Item">
                        <el-select v-model="pagination.status" placeholder="请选择" clearable="clearable" filterable @change="saveSearch()">
                          <el-option  :value="10" label="正在执行"></el-option>
                          <el-option  :value="20" label="执行完成"></el-option>
                          <el-option  :value="30" label="关闭"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="线边超市">
                <el-button v-authority="'BACK_MENU1_M5_B1'" class="btn-t-edit" @click="(add_or_edit = true), (editBoxShow = true)">新增</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
                <!-- <el-table-column prop="authId" label="序号" /> -->
                <el-table-column prop="matCode" label="物料编号" />
                <el-table-column prop="matName" label="物料描述" />
                <el-table-column prop="startTime" label="执行开始时间" />
                <el-table-column prop="endTime" label="执行结束时间" />
                <el-table-column prop="type" label="点位" >
                  <!--
                  <template slot-scope="scope">
                    <span v-if="scope.row.type == '10'">装配</span>
                    <span v-if="scope.row.type == '20'">外圈</span>
                    <span v-if="scope.row.type == '30'">内圈</span>
                  </template>-->
                </el-table-column>
                <el-table-column prop="whCode" label="通道" />
                <el-table-column prop="status" label="状态" >
                  <template slot-scope="scope">
                    <span v-if="scope.row.status == '10'">正在执行</span>
                    <span v-if="scope.row.status == '20'">执行完成</span>
                    <span v-if="scope.row.status == '30'">关闭</span>
                  </template>
                </el-table-column>
                <el-table-column prop="minBoxNum" label="最小包装箱" />
                <el-table-column prop="boxQuan" label="数量" />
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU1_M5_B2'" size="mini" type="primary" @click="
                (add_or_edit = false),
                  (editBoxShow = true),
                  (mainObj = JSON.parse(JSON.stringify(scope.row)))
              " plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU1_M5_B3'" type="danger" @click="closeRow(scope.row)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" width="700px" :model="mainObj" @open="open">
            <span class="formClass">
                <el-form :inline="true" label-position="top" label-width="80px" :model="mainObj" :rules="rules" ref="mainObj">
                    <!-- <cascadeSearch ref="cascadeSearch" :f.sync="mainObj.fcCode" :w.sync="mainObj.shopCode" @change="queryMainData(),mainObj.sectionCode = ''" /> -->
                    <el-form-item label="物料编号" prop="matCode">
                         <el-select v-model="mainObj.matCode" filterable clearable remote :remote-method="remoteMethod" :loading="loading2" @change="remoteMethod">
                           <el-option v-for="item in materialList" :key="item.mtId" :label="item.mtCode" :value="item.mtCode"></el-option>
                         </el-select>

                    </el-form-item>
                    <el-form-item label="执行开始时间" prop="startTime">
                        <el-date-picker v-model="mainObj.startTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" > </el-date-picker>
                    </el-form-item>
                    <el-form-item label="执行结束时间" prop="endTime">
                        <el-date-picker v-model="mainObj.endTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" > </el-date-picker>
                    </el-form-item>
                    <el-form-item label="点位" prop="type">
                      <el-select v-model="mainObj.type" filterable :clearable="true">
                            <el-option v-for="item in this.allDot" :key="item.lrCode" :label="item.lrCode" :value="item.lrCode"></el-option>
                        </el-select>
                      <!--
                        <el-select v-model="mainObj.type" placeholder="请选择" clearable="clearable" filterable>
                             <el-option key="1" value="10" label="装配"></el-option>
                             <el-option key="2" value="20" label="外圈"></el-option>
                             <el-option key="3" value="30" label="内圈"></el-option>

                        </el-select>-->
                    </el-form-item>
                   <el-form-item label="通道" prop="whCode">
                       <el-select v-model="mainObj.whCode" placeholder="请选择" clearable="clearable" filterable>
                          <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode + '-' + item.whName"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="最小包装箱" prop="minBoxNum">
                        <el-input v-model="mainObj.minBoxNum" oninput="value=value.replace(/[^\d]/g,'')">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="数量" prop="boxQuan">
                        <el-input v-model="mainObj.boxQuan" oninput="value=value.replace(/[^\d]/g,'')">
                        </el-input>
                    </el-form-item>


                </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="info" @click="close()">
                    取 消
                </el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">
                    新 增
                </el-button>
                <el-button size="small" type="primary" v-else @click="editRow">
                    修 改
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AuxiMaterial",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                warehouseList:[],
                rules: {
                  matCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    whCode: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                  startTime: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                    type: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                  endTime: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                  minBoxNum: [{
                    required: true,
                    message: '请输入',
                    trigger: 'blur'
                    }],
                  boxQuan: [{
                    required: true,
                    message: '请输入',
                    trigger: 'blur'
                  }],
                },
              /* 所有点位 */
              allDot: [],
                loading2: false, //加载中
                materialList:[],
                mainLine: {
                    authId: null,
                    authName: "",
                    authCode: "",
                    authView: "",
                    authSystem: "",
                    parentId: "",
                    note: "",
                    createTime: "",
                    updateTime: "",
                },
                mainObj: {},
                add_or_edit: Boolean, //新增|编辑
                loading: 0, //加载中
                editBoxShow: false, //编辑框
                EditDialogVisible: false,
                formLabelWidth: "270px",
                tableHeight: 0, //表格高度
                // 分页
                pagination: {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    matCode: "",
                    type: "",
                    status: "",
                },
              insertDate: {
                materialList:[],
              },
                // 页面展示主信息
                mainData: [{
                    authId: null,
                    authName: "",
                    authCode: "",
                    authView: "",
                    authSystem: "",
                    parentId: "",
                    note: "",
                    createTime: "",
                    updateTime: "",
                }, ],

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    },1000)
                },
                deep: true,
            },
        },
        methods: {
            close() {
                this.editBoxShow = false;
                this.mainObj = {}
            },
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.getAuxiMaterialData()
                }, 1000)
            },
          /* 远程搜索物料编号 */
          remoteMethod(query) {
            this.loading2 = true;
            if (query != "") {
              this.mainObj.matCode = query;
              this.getMaterial();
            } else {
              this.mainObj.matCode = "";
              this.getMaterial();
            }
            setTimeout(() => {
              this.loading2 = false;
              if (this.materialList != undefined) {
                this.materialList = this.materialList.filter((item) => {
                  return item.mtCode.toLowerCase().indexOf(query.toLowerCase()) > -1;
                });
              }
            }, 200);
          },
          /**
           * 当前工厂的通道信息
           */
          getWarehouse() {
            this.$http
                .request({
                  url: "/api/warehouse/getWarehouse",
                  method: "GET",
                  params: {
                    fcCode: localStorage.getItem("fcCode") || null,
                  },
                })
                .then((resp) => {
                  if (resp.status == 100) {
                    this.warehouseList = resp.data.list || [];
                  }
                })
                .catch((error) => {});
          },
          //物料列表
          getMaterial() {
            this.$http
                .request({
                  url: "/api/material/getMaterialAll",
                  method: "GET",
                  params: {
                    fcCode: localStorage.getItem("fcCode")  || null,
                    mtCode: this.mainObj.matCode || null,
                    pageNum: 1,
                    pageSize: 1000,
                  },
                })
                .then((res) => {
                  if (res.status == 100) {
                    this.materialList = res.data.list;
                  } else {
                    this.$message.error("错误");
                  }
                });
          },
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "/api/lineSupermarket/getLineSupermarketAll",
                        method: "GET",
                        params: {
                            pageNum: this.pagination.pageNum,
                            pageSize: this.pagination.pageSize,
                            matCode: this.pagination.matCode,
                            type: this.pagination.type,
                            status: this.pagination.status,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {});
            },
          /* 获取所有点位 */
          getSysLineAndPointRouterAll() {
            this.$http
                .request({
                  url: "/api/sysLineRouter/getSysLineRouter",
                  method: "GET",
                  params:{
                    fcCode: localStorage.getItem("fcCode")
                  }
                })
                .then((res) => {
                  if (res.status == 100) {
                    this.allDot = res.data.list;
                  }
                });
          },

            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },
            //框打开
            open() {
                if (this.add_or_edit) {
                    //新增
                    this.mainObj = JSON.parse(
                        JSON.stringify({
                            authId: null,
                            authName: "",
                            authCode: "",
                            authView: "",
                            authSystem: "",
                            parentId: "",
                            note: "",
                            createTime: "",
                            updateTime: "",
                            person: localStorage.getItem("user"),
                            personNumber: localStorage.getItem("empNumber"),
                        })
                    );
                } else {
                    this.getAuxiMaterialData();
                }
            },
            //新增
            add() {
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/lineSupermarket/insertLineSupermarket",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.logRemarks = "authority：权限新增成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "authority：权限新增失败";
                            }
                            this.logContent = "authCode：" + this.mainObj.authCode;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //编辑
            editRow() {
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/lineSupermarket/updateLineSupermarket",
                            method: "PUT",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "修改成功！",
                                    type: "success",
                                });
                                this.logRemarks = "lineSupermarket：修改成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "authority：权限修改失败";
                            }
                            this.logContent = "authCode：" + this.mainObj.authCode;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //关闭
            closeRow(dataPo) {
                this.$confirm("此操作将关闭该数据, 是否继续?", "提示", {
                        confirmButtonText: "关闭",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/lineSupermarket/closeLineSupermarket",
                                method: "PUT",
                                showLoading: true,
                                data: dataPo,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "关闭成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "closeLineSupermarket：关闭成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: resp.message,
                                    });
                                    this.logRemarks = "closeLineSupermarket：权限删除成功";
                                }
                                this.logContent = "dataPo：" + dataPo;
                                this.systemLog();
                                this.getAuxiMaterialData();
                            })
                            .catch((error) => {
                                this.$notify.error({
                                    title: "失败",
                                    message: "调用失败",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },

            //重置
            resetData() {
                this.pagination = {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    authCode: "",
                    authName: "",
                    authSystem: "",
                };
                this.getAuxiMaterialData();
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "线边超市管理",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
            this.getWarehouse();
            this.getSysLineAndPointRouterAll();
        },
    };
</script>

<style scoped>
</style>